import React from 'react';
// import { Link } from 'react-router-dom';
import { Link } from 'react-router-dom';
import Main from '../layouts/Main';

// import Cell from '../components/Projects/Cell';
// import data from '../data/projects';

const Talks = () => (
  <Main
    title="Talks"
    description="Learn about Praveen Kumar Ramesh's talks."
  >
    <header>
      <div className="title">
        <h2 data-testid="heading"><Link to="talks">Resources</Link></h2>
        <p>
          Hi, here are some of the resources that I authored. I hope they are useful to you.
        </p>
      </div>
    </header>
    <article className="post" id="projects">
      <div>
        <h4>Machine Learning</h4>
        <p>
          This <a href="http://pbcpraveen.github.io/files/Machine_Learning.pdf"> document </a>
          provides the fundamental understanding of machine leaning.
          You can also find how to implement simple algorithms like Linear Regression and Logistic
          Regression. I have attempted to derive the gradients to implement gradient descent for
          these two algorithms. I hope people who are new to ML find this useful.
        </p>
      </div>
    </article>
    <article className="post" id="projects">
      <div>
        <h4>Deep Learning</h4>
        <p>
          This <a href="http://pbcpraveen.github.io/files/Back_Propagation.pdf">document </a>
          explains the mathematical modeling of Artificial Neural Network, with explanations to
          general notations used in various research works. I have attempted to break down the math
          with detailed explanation to every steps. The vanilla back propagation algorithm, a
          variation of which is currently used for many state of art models, is also explained with
          a simple example. I hope this will be useful for people who have just started with DL.
        </p>
      </div>
    </article>
    <article className="post" id="projects">
      <div>
        <h4>Image Processing</h4>
        <p>
          This <a href="http://pbcpraveen.github.io/files/ImageProcessing.pdf"> document </a>
          contains a basic introduction to image processing and will guide you to do a complete
          installation of anaconda software along with all libraries needed to do Image Processing
          and Deep Learing in python. I have also uploaded few sample code in
          this <a href="https://github.com/pbcpraveen/I-Cell">repository</a>.
        </p>
      </div>
    </article>
  </Main>
);

export default Talks;
